import FlightRulesLink from './flight-rules-link-component';

import './flight-rules-link.scss';

const MODULE_NAME = 'app.flight.rules-link';
const module = angular.module(MODULE_NAME, [])
    .directive(FlightRulesLink.DIRECTIVE_NAME, FlightRulesLink);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/flights/flight-rules-link/flight-rules-link-module.js